import {Injectable} from "@angular/core";
import {DisplayService} from "@app/presentation/services/display.service";
import {SideSheetService} from "@app/presentation/services/side-sheet/side-sheet.service";
import {ComponentType} from "@angular/cdk/overlay";
import {Router} from "@angular/router";
import {take} from "rxjs/operators";
import {LocalizeRouterService} from "@gilsdav/ngx-translate-router";

@Injectable({
    providedIn: 'root'
})
export class ConditionalSideSheetService<T = any> {
    constructor(
        private displayService: DisplayService,
        private sideSheetService: SideSheetService,
        private router: Router,
        private localizeRouterService: LocalizeRouterService,
    ) {
    }

    open(url: any[], component: ComponentType<T>) {
        this.displayService.isMobileDisplay$
            .pipe(take(1))
            .subscribe({
                next: isMobile => {
                    if(isMobile) {
                        const localizedUrl = this.localizeRouterService.translateRoute(url)
                        this.router.navigate([...localizedUrl]);
                        return;
                    }
                    this.sideSheetService.open(component)
                }
            });
    }
}
